import {getAllEvents} from "./action";

const getAllEventsAction = () => getAllEvents();

export default {
    getAllEventsAction,
}
